import { combineReducers } from 'redux'

import authorization from './authorization'
import organization from './organization'
import user from './user'

const csr = combineReducers({
  authorization,
  organization,
  user,
})

export default csr
